export interface Patient {
  id: number;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: 'M' | 'F' | 'O';
  identificationNumber: string;
  phone?: string;
  email?: string;
  address?: string;
  evaluatorId: string; // Cambiado a string (UUID)
  status: 'activo' | 'inactivo';
  educationYears?: number;
  createdAt: string;
  updatedAt: string;
  evaluator?: {
    id: string; // Cambiado a string (UUID)
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface PatientFormData {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: 'M' | 'F' | 'O';
  identificationNumber: string;
  phone?: string;
  email?: string;
  address?: string;
  evaluatorId: string; // Cambiado a string (UUID)
  educationYears?: number;
}

export interface PatientFilters {
  search?: string;
  evaluatorId?: string; // Cambiado a string (UUID)
  sortBy?: 'firstName' | 'lastName' | 'createdAt' | 'dateOfBirth';
  order?: 'ASC' | 'DESC';
}

export interface PatientListResponse {
  patients: Patient[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface PatientValidationErrors {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  gender?: string;
  identificationNumber?: string;
  phone?: string;
  email?: string;
  address?: string;
  evaluatorId?: string;
  educationYears?: string;
}

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Femenino' },
  { value: 'O', label: 'Otro' }
];

export const SORT_OPTIONS = [
  { value: 'firstName', label: 'Nombre' },
  { value: 'lastName', label: 'Apellido' },
  { value: 'createdAt', label: 'Fecha de creación' },
  { value: 'dateOfBirth', label: 'Fecha de nacimiento' }
]; 